import { NotificationForegroundWillDisplayEvent } from 'react-onesignal';

export function handleForegroundWillDisplay(
  event: NotificationForegroundWillDisplayEvent
): void {
  // Show the browser push only when the app is NOT in front (closed, minimized,
  // or in a background tab). When the admin is actively viewing the app, the
  // in-app notification (bell/sound, chat panel) already covers it, so suppress
  // the duplicate browser push. `document.hasFocus()` is true only while the
  // window is the active one and the tab is foregrounded.
  if (document.hasFocus()) {
    event.preventDefault();
  }
}
